export default (state = null, action) => {

    switch (action.type) {
        case 'ENQUIRY_CREATED':
            return action.payload;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/enquiryUid_reducer.js